import {ApiService} from "./ApiService";
import UrlEndpoints from "./UrlEndpoints";

export default class BuildService {
    static async addBuild(request) {
        await ApiService.post(UrlEndpoints.BUILD, request)
    }

    static async getBuilds() {
        const builds = await ApiService.get(UrlEndpoints.BUILD);
        return builds;
    }

    static async removeBuild(id) {
        await ApiService.delete(UrlEndpoints.BUILD+"/"+id);
    }

    static async updateGoldenBuild(request) {
        await ApiService.post(UrlEndpoints.GOLDEN_BUILD, request);
    }

    static async getDeviceList(emailOrMac) {
        const body = {
            "emailOrMac": emailOrMac
        };
        try {
            const response =  await ApiService.post(UrlEndpoints.DEVICE_LIST, body);
            return response;
        } catch (error) {
           if(error.response && error.response.data){
              throw new Error(error.response.data.message);
           }
        }
    }
}

